module.exports = __webpack_public_path__ + "img/10-02.7b5b5b41.svg";